import React from "react";
import Slider from "react-slick";
import { StaticImage } from "gatsby-plugin-image";

const HealthCampSection = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: false,
    speed: 3000,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="row">
        <div className="col-md-12 col-sm-12 col-12">
          <h2>Health Camps</h2>
          <Slider {...settings}>
            <div className="card1">
              <StaticImage
                className="healthImg"
                src="../../../assets/images/kmc-images/HealthCamps/dental_screening_new.png"
                alt="Blood Donation Camp"
              />
              <div className="health-lists otherservice-height otherservice-heights">
                <h2>Dental Screening Camp</h2>
                <p>
                  Kanha medical centre conducted dental screening and awareness
                  sessions about dental hygiene for 744 children at THLC on 30th
                  Nov 2022.
                </p>
                <p className="health-publishDate">November 30, 2022</p>
              </div>
            </div>
            <div className="card2">
              <StaticImage
                className="healthImg"
                src="../../../assets/images/kmc-images/HealthCamps/kidsvaccin.jpg"
                alt="KMC Kids Vaccin"
              />
              <div className="health-lists otherservice-height otherservice-heights">
                <h2>Covid Vaccination Children at KMC</h2>
                <p>Covid Vaccination Children at KMC on 25th June</p>
                <p className="health-publishDate">June 25, 2022</p>
              </div>
            </div>
            <div className="card3">
              <StaticImage
                className="healthImg"
                src="../../../assets/images/kmc-images/HealthCamps/Oral-polio.png"
                alt="MMR Vaccination Camp"
              />
              <div className="health-lists otherservice-height otherservice-heights">
                <h2>Oral Polio Vaccine Camp</h2>
                <p>Oral philosophy vaccine at kmc on 13th April</p>
                <p className="health-publishDate">February 12, 2022</p>
              </div>
            </div>
            <div className="card4">
              <StaticImage
                className="healthImg"
                src="../../../assets/images/kmc-images/HealthCamps//Diabetes.png"
                alt="Diabetes Awareness Camp"
              />
              <div className="health-lists">
                <h2>Diabetes Awareness Camp</h2>
                <p>
                  KMC organises regular diabetes camps for surrounding villagers
                  and members of the mission
                </p>
                <p className="health-publishDate">February 12, 2022</p>
              </div>
            </div>
            <div className="card5">
              <StaticImage
                className="healthImg"
                src="../../../assets/images/kmc-images/HealthCamps/Blood-donation.png"
                alt="Blood Donation Camp"
              />
              <div className="health-lists otherservice-height otherservice-heights">
                <h2>Blood Donation Camp</h2>
                <p>
                  KMC organises blood donation camps in collaboration with NGO`s
                </p>
                <p className="health-publishDate">February 12, 2022</p>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </>
  );
};

export default HealthCampSection;
